import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import history from 'services/history'
import RestrictedRoute from './RestrictedRoute'

export default function SwitchRouter({ children }) {

    const { location: { pathname: path } } = history
    const newChildren = Array.isArray(children) ? 
        children.map((child, i) => 'restricted' in child.props ? <RestrictedRoute key={i} {...child.props} /> : child) 
        : 'restricted' in children.props ? <RestrictedRoute {...children.props} /> : children
    return (
        <Switch>
            {newChildren}
            <Route render={() => <Redirect to={{ pathname: "/pagina-nao-encontrada", state: { path } }} />} />
        </Switch>
    )
}
